module.exports = __webpack_public_path__ + "static/img/equipmentdanger.033c2b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/equipmentdanger.png
// module id = XnHc
// module chunks = 1